import React from "react";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate } from "react-router-dom";

const AboutSection = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{ background: "#fff", py: 6 }}>
            <Container maxWidth="lg">
                <Grid container spacing={4} alignItems="center">

                    {/* LEFT IMAGE */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            component="img"
                            src="https://sudarshanholiday.com/images/home/14.jpg" // replace with your image
                            alt="travel"
                            sx={{
                                width: "100%",
                                height: "auto",
                                borderRadius: "14px",
                                objectFit: "cover",
                            }}
                        />
                    </Grid>

                    {/* RIGHT CONTENT */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        {/* TITLE + ICON */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                mb: 1,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: "28px",
                                    fontWeight: 700,
                                    color: "#2b5c9e",
                                }}
                            >
                                Our Awesome Story
                            </Typography>

                            <KeyboardArrowDownIcon sx={{ color: "#2b5c9e" }} />
                        </Box>

                        {/* LINE */}
                        <Box
                            sx={{
                                height: "1px",
                                background: "#e0e6ed",
                                mb: 2,
                            }}
                        />

                        {/* PARAGRAPH */}
                        <Typography
                            sx={{
                                color: "#7a869a",
                                fontSize: "14px",
                                lineHeight: 1.8,
                                mb: 2,
                            }}
                        >
                            No matter how expensive a house you own or how much salary you get,
                            nothing can offer more pleasure and satisfaction than a wonderful
                            vacation with family and friends. We all want to rejuvenate
                            ourselves by conducting multiple vacations to get rid of our dull
                            and dreary life. Here comes the need for an efficient and
                            experienced travel agency that can take you away from your routine
                            monotonous life and offer huge happiness by making you witness
                            vacations like never before.
                        </Typography>

                        <Typography
                            sx={{
                                color: "#7a869a",
                                fontSize: "14px",
                                lineHeight: 1.8,
                                mb: 3,
                            }}
                        >
                            Among those very few travel agencies that can offer ever-remarkable
                            travel experiences to travellers, Sudarshan Holidays is certainly a
                            remarkable one. We are one of the leading travel agencies in
                            Bangalore, Karnataka that offer a stunning travel experience to
                            clients with incredible service and value.
                        </Typography>

                        {/* BUTTON */}
                        <Button
                            onClick={() => navigate("/contact-us")}
                            variant="contained"
                            endIcon={<GroupsIcon />}
                            sx={{
                                background: "#4fb3df",
                                textTransform: "none",
                                fontWeight: 600,
                                px: 3,
                                py: 1.2,
                                borderRadius: "6px",
                                boxShadow: "none",
                                "&:hover": {
                                    background: "#3aa2cf",
                                },
                            }}
                        >
                            Contact Our Team
                        </Button>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default AboutSection;